module.exports = __webpack_public_path__ + "img/nl.5163de7a.svg";